
import Mobile from "../../../assets/outline/Mobile.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MobileIcon({ className, dataTestid = "MobileIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Mobile data-testid={dataTestid} className={classes} {...rest} />
  );
}
